import { Skeleton } from '@mui/material';

export const skeletonRestaurantHeader = () => {
  return (
    <>
      <div className=''>
        <div className='d-flex justify-content-center'>
          <Skeleton
            sx={{ bgcolor: 'grey.900', borderRadius: '20px' }}
            variant='rectangular'
            width={150}
            height={55}
          />
        </div>
        <div className='mt-4'>
          <Skeleton
            sx={{ bgcolor: 'grey.900', borderRadius: '20px' }}
            variant='rectangular'
            width={'100%'}
            height={112}
          />
        </div>
        <div className='mt-2'>
          <Skeleton
            sx={{ bgcolor: 'grey.900', borderRadius: '20px' }}
            variant='rectangular'
            width={'100%'}
            height={112}
          />
        </div>
        <div className='mt-2'>
          <Skeleton
            sx={{ bgcolor: 'grey.900', borderRadius: '20px' }}
            variant='rectangular'
            width={'100%'}
            height={112}
          />
        </div>
        <div className='mt-2'>
          <Skeleton
            sx={{ bgcolor: 'grey.900', borderRadius: '20px' }}
            variant='rectangular'
            width={'100%'}
            height={112}
          />
        </div>
        <div className='mt-2'>
          <Skeleton
            sx={{ bgcolor: 'grey.900', borderRadius: '20px' }}
            variant='rectangular'
            width={'100%'}
            height={112}
          />
        </div>
        <div className='mt-2'>
          <Skeleton
            sx={{ bgcolor: 'grey.900', borderRadius: '20px' }}
            variant='rectangular'
            width={'100%'}
            height={112}
          />
        </div>
      </div>
    </>
  );
};

export const skeletonRestaurantCard = () => {
  return (
    <>
      <div className='mt-5'>
        <Skeleton
          sx={{ bgcolor: 'grey.900', borderRadius: '20px' }}
          variant='rectangular'
          width={'100%'}
          height={112}
        />
      </div>
    </>
  );
};
